import {NavigationKey} from '../navigations/config';
import {navigate} from './nav.utils';

const buildNotificationConsultationParams = <T extends Record<string, any>>(
  params: T,
) => ({
  ...params,
  fromNotifications: true,
});

const navigateToNotificationConsultation = (params: Record<string, any>) => {
  navigate(
    NavigationKey.CONSULTATION_DETAIL,
    buildNotificationConsultationParams(params),
  );
};

export {
  buildNotificationConsultationParams,
  navigateToNotificationConsultation,
};
